import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Container,
} from '@mui/material';

interface HeaderProps {
  onToggleTheme: () => void;
  isDarkMode: boolean;
}

const Header: React.FC<HeaderProps> = ({ onToggleTheme, isDarkMode }) => {
  return (
    <AppBar 
      position="static" 
      elevation={0}
      sx={{ 
        backgroundColor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        color: 'text.primary'
      }}
    >
      <Container maxWidth="xl">
        <Toolbar 
          sx={{ 
            minHeight: '64px',
            px: { xs: 2, sm: 3 },
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          {/* Left - Logo with "Empowered by" */}
          <Box
            component="a"
            href="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              gap: 1
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: '#fefefe',
                fontSize: '0.875rem',
                fontWeight: 500
              }}
            >
              Empowered by
            </Typography>
            <img
              src="https://mintcdn.com/ravenpackinternational/bcUBOLUZVgrT-4Je/logo/logo_ribbon_horiz_inverted@4x.png?fit=max&auto=format&n=bcUBOLUZVgrT-4Je&q=85&s=aee542b66e26222f9d83c382ae0cb1a1"
              alt="BigData Logo"
              style={{
                height: '28px',
                width: 'auto',
                objectFit: 'contain'
              }}
            />
          </Box>
          
          {/* Center - App Name */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: '#fefefe', // Egg white color
              fontSize: '1.25rem',
              letterSpacing: '-0.02em',
              textAlign: 'center'
            }}
          >
            Earnings calls for top 3000 US companies
          </Typography>
          
          {/* Right spacer for centering */}
          <Box sx={{ width: '28px' }} />
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
